export const commonExtractedMessages = {
  "common.App.notFound": "Not Found",
  "common.AppErrorBoundary.description":
    "The page could not be displayed. Reload the application to continue.",
  "common.AppErrorBoundary.reload": "Reload Celsus",
  "common.AppErrorBoundary.title": "Celsus needs a fresh start",
  "common.Brand.celsusHome": "Celsus home",
  "common.Brand.legeFruereCommunica": "Lege · Fruere · Communica",
  "common.Button.loading": "Loading",
  "common.Dialog.closeDialog": "Close dialog",
  "common.HomePage.keepAThoughtfulLibraryRememberEveryReading":
    "Keep your books, notes, reading sessions, and progress together.",
  "common.HomePage.historyDescription":
    "Review your history by day, book, or reading session.",
  "common.HomePage.historyTitle": "History",
  "common.HomePage.lastSession": "Last session: 41 pages · 38 minutes",
  "common.HomePage.libraryDescription":
    "Editions, status, notes, and progress stay with each book.",
  "common.HomePage.libraryTitle": "Library",
  "common.HomePage.logDescription":
    "Record pages and time without leaving your current read.",
  "common.HomePage.logTitle": "Reading log",
  "common.HomePage.makeMoreRoomForTheBooksThat": "Keep track of the books you read.",
  "common.HomePage.mondayShort": "Mon",
  "common.HomePage.previewDate": "Thursday, 22 October",
  "common.HomePage.previewBookAuthor": "Mikhail Bulgakov",
  "common.HomePage.previewBookTitle": "The Master and Margarita",
  "common.HomePage.previewLabel": "Celsus reading dashboard preview",
  "common.HomePage.previewProgress": "262 of 384 pages",
  "common.HomePage.signIn": "Sign in",
  "common.HomePage.startYourLibrary": "Start your library",
  "common.HomePage.sundayShort": "Sun",
  "common.Layout.accountNavigation": "Account navigation",
  "common.Layout.login": "Login",
  "common.Layout.mobileNavigation": "Mobile navigation",
  "common.Layout.navigationMenu": "Navigation menu",
  "common.Layout.register": "Register",
  "common.Layout.skipToMainContent": "Skip to main content",
  "common.Sidebar.logOut": "Log out",
  "common.Sidebar.primaryNavigation": "Primary navigation",
  "common.ToastRegion.dismissNotification": "Dismiss notification",
} as const;
